import React, {Component} from "react";
import _ from "lodash";
import {withStyles} from "@material-ui/core/styles";

import {getSharedStyles} from "../themes";
import PropTypes from "prop-types";
import PopOver from "./ui/PopOver";
import WarningIcon from "@material-ui/icons/Warning";
import InfoIcon from "@material-ui/icons/Info";
import ErrorIcon from "@material-ui/icons/Error";
import UpArrow from "../images/icons/upArrow";
import DownArrow from "../images/icons/downArrow";
import QuestionIcon from "@material-ui/icons/Help";
const styles = (theme) => ({
	...getSharedStyles(theme),
	warning : {
		color : '#FFC107',
		width : 16,
		height : 16,
		paddingRight : 3,
	},
	error : {
		color : '#e53935',
		width : 20,
		height : 20,
		paddingRight : 3,
	},
	question : {
		color : '#91b5b9',
		width : 20,
		height : 20,
		paddingRight : 3,
	},
	info : {
		color : '#2196F3',
		width : 20,
		height : 20,
		paddingRight : 3,
	},
});

class SaleCell extends Component {
	render() {
		const { classes, salesRow,doNotShowQuestion} = this.props;

		//- New showing amount
		const contents = [];
		[
			'warning', 'note','error', 'info', 'question',
			'saleHigh', 'saleVeryHigh', 'saleLow', 'saleVeryLow'
		].forEach(s => {
			if (!salesRow[s]) { return; }
			contents.push({ type : s, text : salesRow[s]});
		});
		const display = (_.isNumber(salesRow.volume)) ? salesRow.volume : '-';

		let saleDisplay;
		if (_.isEmpty(contents)) {
			saleDisplay = display;
		} else {
			const popoverValue = _.map(contents, 'text').join('.  ');
			saleDisplay = (
				<PopOver value={popoverValue}>
					{contents.map(({ type }, i) => {
						if (type === 'warning') {
							return (<WarningIcon className={classes.warning} key={i}/>);
						} else if (type === 'info') {
							return (<InfoIcon className={classes.info} key={i}/>);
						} else if (type === 'error') {
							return (<ErrorIcon className={classes.error} key={i}/>);
						} else if (type === 'saleHigh') {
							return (<UpArrow fill={'#9E9D24'} key={i} />);
						} else if (type === 'saleVeryHigh') {
							return (<UpArrow fill={'#EF6C00'} key={i} />);
						} else if (type === 'saleLow') {
							return (<DownArrow fill={'#00897B'} key={i} />);
						} else if (type === 'saleVeryLow') {
							return (<DownArrow fill={'#8E24AA'} key={i} />);
						} else {
							if (doNotShowQuestion) {
								return null;
							} else {
								return (
									<QuestionIcon className={classes.question} key={i}/>
								);
							}
						}
					})}
					{display}
				</PopOver>
			);
		}
		return saleDisplay;
	}
}

SaleCell.propTypes = {
	salesRow : PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
	authUser : PropTypes.object,
	doNotShowQuestion : PropTypes.bool,
};

export default _.flow([
	withStyles(styles),
])(SaleCell);
